import { IAjax } from 'lib/Ajax';
import { AutoSavingDraftObject } from 'lib/autoSave';
import { PostalAddress as ServerPostalAddress } from 'data/models/PostalAddress';

export type PostalAddress = ReturnType<typeof PostalAddress>;
export function PostalAddress(ajax : IAjax, postalAddress : ServerPostalAddress, deleteFn? : (ts : Date) => void) {
    let client = ajax.Url<ServerPostalAddress>(() => postalAddress.Url() || ''),
        draft = AutoSavingDraftObject(postalAddress, client);

    return {
        Model: draft,
        Delete: Delete,
        CanDelete: !!deleteFn
    };

    function Delete() {
        if (deleteFn) {
            let req = client.Delete();
            req.then(() =>
                deleteFn(req.Date)
            );
        }
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/postaladdress/model.ts